module.exports = __webpack_public_path__ + "img/register1.b95a2192.png";